import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import { routes } from './app.routes';
import { AuthInterceptor } from './auth/auth.interceptor';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { ErrorInterceptor } from './auth/error.interceptor';
import { loaderInterceptor } from './auth/loader.interceptor';
import { idempotencyInterceptor } from './auth/idempotency.interceptor';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),

    provideHttpClient(
      withInterceptorsFromDi(), // pick up AuthInterceptor & ErrorInterceptor
      // idempotencyInterceptor FIRST: it may answer a duplicate request from an
      // in-flight one without calling next(), so it must sit outside the loader.
      withInterceptors([idempotencyInterceptor, loaderInterceptor])
    ),
    provideAnimations(),
    importProvidersFrom(NgbModule, FormsModule, ReactiveFormsModule),

    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    provideAnimations(),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
  ],
};
